const PowerBIMenuSvg = (props) => {
  return (
    <svg
      width={22}
      height={22}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
    >
      <rect
        x="18"
        y="7"
        width="4"
        height="13"
        rx="1"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="10"
        y="13"
        width="4"
        height="7"
        rx="1"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="2"
        y="9"
        width="4"
        height="11"
        rx="1"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default PowerBIMenuSvg
